import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import { Container } from 'reactstrap';
import styles from './styles.module.scss';

export const ColumnItems = ({
  className,
  title,
  titleColour,
  content,
  items,
  textAlign = "center",
}) => {

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <header className={`text-${textAlign} mb-5`}>
          {title &&
            <h2 className={`text-${titleColour?.variant}`} style={{color: titleColour?.custom}}>{title}</h2>
          }
          {content &&
            <div dangerouslySetInnerHTML={{ __html: content }} />
          }
        </header>
        {items && items.length > 0 && (
          <div className={`${styles.gridContainer} row`}>
            {items.map((item, index) => (
              <div key={index} className={`col-md-4 d-flex flex-column align-items-stretch text-${item?.textAlign ?? "center"}`}>
                {item?.image &&
                  <figure className="d-flex justify-content-center align-items-center">
                    <SourceFlowImage
                      src={
                        item?.image.url
                          ? item.image.url
                          : "/site-assets/placeholders/icon-placeholder.jpg"
                      }
                      size="200x"
                      alt={item?.alt ?? item?.title}
                      className="w-50"
                    />
                  </figure>
                }
                <article className="my-4 px-4 flex-grow-1">
                  {item?.title &&
                    <h3 className={`text-${item?.titleColour?.variant}`} style={{color: item?.titleColour?.custom}}>{item?.title}</h3>
                  }
                  {item?.content &&
                    <div dangerouslySetInnerHTML={{ __html: item?.content }} />
                  }
                </article>
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );

}

export default ColumnItems;
